import { Grid } from '@radix-ui/themes';
import { PitchPerfPlotBreaks } from 'components/sections/admin-portal/machines/dialogs/pitch-performance/plots/plot-break-stdev';
import { PitchPerfPlotPlate } from 'components/sections/admin-portal/machines/dialogs/pitch-performance/plots/plot-plate-location';
import { MachinePerformanceHelper } from 'lib_ts/classes/machine-performance.helper';
import { IGroupedFires } from 'lib_ts/interfaces/i-pitch-performance';
import { useMemo } from 'react';
import usePitchPerformanceStore from '../store/use-pitch-performance-store';

export const PitchPerfPlots = (props: { pitches: IGroupedFires[] }) => {
  const { isAveraged, selectedShotIds } = usePitchPerformanceStore();
  const showDrilledDownAverage = isAveraged && selectedShotIds.length > 0;

  /**
   * If the user has selected specific shots from the ShotTable,
   * we'll re-calculate our averages using those selected shots only.
   */
  const groups = useMemo(() => {
    if (!showDrilledDownAverage) {
      return props.pitches;
    }

    // returns a clone of the original to avoid polluting with avgs and deltas based on past selections
    return props.pitches.map((p) =>
      MachinePerformanceHelper.cloneWithAvgAndDelta({
        ...p,
        // shot exists and is selected
        fires: p.fires.filter((f) => selectedShotIds.includes(f.shot._id)),
      })
    );
  }, [props.pitches, showDrilledDownAverage, selectedShotIds]);

  return (
    <Grid
      columns={{
        md: '1',
        lg: '2',
      }}
      gap="4"
    >
      <PitchPerfPlotBreaks groups={groups} />
      <PitchPerfPlotPlate groups={groups} />
    </Grid>
  );
};
